<template>
  <div class="lineitems">
    <div class="lineitems__item" v-for="cart in lineItems">
        <a href="#" @click.prevent="selectedItem = cart.id, showConfirm = true" v-if="allowDelete" class="lineitems__remove">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17C13.4 17 17 13.4 17 9C17 4.6 13.4 1 9 1C4.6 1 1 4.6 1 9C1 13.4 4.6 17 9 17Z" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.73438 11.2623L11.2624 6.73438" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.2624 11.2623L6.73438 6.73438" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </a>
        <div class="lineitems__header">
            <div class="lineitems__image"><img :src="cart.image" alt=""></div>  
            <div class="lineitems__details">
                <div class="lineitems__space">{{ cart.group }} | {{ cart.title }}</div>
                <div class="lineitems__date-wrap">
                    <div class="lineitems__date">{{ cart.start | moment }} - {{ cart.end | moment }}</div>
                    <template v-if="editDates">
                    <DatePickerButton 
                      @input="updatePrice(cart.listing_id, cart.id, $event)" 
                      :range="true"
                      :value="null"
                      :columns="2"
                      :class="'lineitems__picker'"
                      :allowMinDate="true"
                      :mini="true"
                      :disabledDates="disabledDates[cart.listing_id]"
                      >
                    </DatePickerButton>
                    </template>
                </div>
            </div>      
        </div>

        <template v-if="cart.price !== 'A consultar'">
        <div class="lineitems__hr"></div>
        <div class="lineitems__payments">
            <table>
                <tr v-for="(stage, index) in cart.pay_schedule">
                    <td>{{ $store.getters.language.payment }} {{ index + 1 }}</td>
                    <td>|</td>
                    <td>{{ stage.date }}</td>
                    <td>€{{ stage.amount.toFixed(2) }}</td>
                </tr>
            </table>
        </div>
        </template>
        
        <div class="lineitems__hr"></div>
        <div class="lineitems__totals">
            <div class="lineitems__line lineitems__line--bold">
                <div class="lineitems__cell">{{ $store.getters.language.total }}</div>
                <div class="lineitems__cell">{{ cart.price === 'A consultar' ? cart.price : '€' + cart.price }}</div>
            </div>
        </div>
    </div>
    <ConfirmNotification v-if="showConfirm" :title="$store.getters.language.remove_space" :message="$store.getters.language.are_your_sure" @back="showConfirm = false, selectedItem = null" @remove="removeBooking()" buttonType="button"></ConfirmNotification>
  </div>
</template>

<script>
    import moment from 'moment'
    import axios from 'axios'
    import ButtonPrimary from "../../components/global/ButtonPrimary"
    import ButtonSecondary from "../../components/global/ButtonSecondary"
    import ButtonAccept from "../../components/global/ButtonAccept"
    import DatePickerButton from "../../components/global/DatePickerButton"
    import ConfirmNotification from "../../components/pitch/ConfirmNotification"

    export default {
        name: 'LineItems',
        data: () => ({
            items: null,
            date: null,
            locale: null,
            disabledDates: {},
            selectedItem: null,
            showConfirm: false
        }),
        props: {
            lineItems: {
                default: null,
                type: Array
            },
            acceptButton: {
                default: false,
                type: Boolean
            },
            acceptTermsArray: {
                default: null,
                type: Array    
            },
            editDates: {
                default: false,
                type: Boolean
            },
            allowDelete: {
                default: true,
                type: Boolean
            }
        },
        components: {
            ButtonPrimary,
            ButtonSecondary,
            ButtonAccept,
            DatePickerButton,
            ConfirmNotification
        },
        mounted(){
            // this.getCartItems()
            moment.locale(current_locale)
            this.locale = current_locale
            this.loadDisabledDates()
        },
        methods: {
            removeBooking() {
                var self = this 
                var booking_id = this.selectedItem
                axios
                    .get('/api/pitches/delete_booking?booking_id=' + booking_id)
                    .then(response => {
                        self.lineItems = response.data.items
                        self.$emit('updateItems')
                        self.selectedItem = null
                        self.showConfirm = false
                    })
            },
            async loadDisabledDates() {
                // Load disabled dates for each item in lineItems
                for (const item of this.lineItems) {
                    await this.setDisabledDates(item.listing_id);
                }
            },
            updatePrice (listing_id, booking_id, range) {
                console.log(listing_id, booking_id, range)
              var self = this
              var token = document.head.querySelector("[name=csrf-token]").content
              var data = {
                listing_id: listing_id,
                booking_id: booking_id,
                return_type: 'lowest_for_year',
                to_date: range.end,
                from_date: range.start
              }
              axios.post('/rent/update_price',
                  {
                    listing_id: listing_id,
                    booking_id: booking_id,
                    return_type: 'lowest_for_year',
                    to_date: range.end,
                    from_date: range.start
                  },
                { headers: {
                        'Content-type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-Token': token
                    }
                }).then(response => {
                    console.log(response)
                    self.$emit('updateItems')
              })
            },
            async setDisabledDates(id) {
                try {
                    const response = await axios.get('/api/bookings/get_calendar_data_for_space?listing_id=' + id);
                    const dates = response.data.map(item => new Date(item));
                    this.$set(this.disabledDates, id, dates);
                } catch (error) {
                    console.error('Error fetching disabled dates:', error);
                    this.$set(this.disabledDates, id, []);
                }
            }
        },
        filters: {
            moment: function (date) {
                return moment(date).format('DD MMM');
            }
        }
    }
</script>

<style scoped lang="scss">
@import "../../scss/global/includes";

.lineitems {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    @include breakpoint(tablet) {
        grid-template-columns: 1fr;
    }
}

.lineitems__item {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    border: 1px dashed $divider-dark;
    border-radius: 10px;
    padding: 32px;
    position: relative;
}

.lineitems__remove {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1001;
}

.lineitems__centre {
    width: 100%;
    @include responsive-text-size('Title--20--Bold');
}

.lineitems__space {
    width: 100%;
    @include responsive-text-size('Header--16--BOLD');
}

.lineitems__date-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}


.lineitems__date {
    width: 100%;
    @include responsive-text-size('Body--16--Regular');
}

.lineitems__header {
    display: flex;
    gap: 16px;
    align-items: flex-start;
}

.lineitems__image {
    width: 96px;
    max-width: 100%;
    border-radius: 4px;
    overflow: hidden;
    line-height: 0;

    img {
        aspect-ratio: 1/1;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.lineitems__details {
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    position: relative;
}

.lineitems__totals {
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 0px;
}

.lineitems__line {
    display: flex;
    justify-content: space-between;
    gap: 4px;
    width: 100%;

    &.lineitems__line--bold {
        @include responsive-text-size('Body--16--Bold');
    }
}

.lineitems__hr {
    width: 100%;
    border-top: 1px dashed $primary-grey;
}

.lineitems__payments {
    width: 100%;
    tr, table {
        width: 100%;
    }
    td {
        padding: 0 10px 10px 0;
        @include responsive-text-size('Body--14--Regular');
        &:nth-child(1) {
            min-width: 100px;
            @include responsive-text-size('Body--16--Bold');
        }
        &:last-child {
            padding-right: 0;
            text-align: right;
        }
    }
}

</style>
